// TODO IMPROVEMENT: Modify backend response for camelCase

export interface IInvestmentTrust {
  id: number;
  name: string;
}

export class InvestmentTrust implements IInvestmentTrust {
  constructor(
    public id: number,
    public name: string,
  ) {}
}
